// src/utils/httpRequest.js
// 创建基础配置
const config = {
  // Vue CLI 项目中使用 process.env
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.NODE_ENV === 'development' ? 5000 : 10000,
  headers: {
    'Content-Type': 'application/json'
  }
}

// 获取 token
const getToken = () => {
  return localStorage.getItem('token')
}

// 添加 token 到 headers
const getHeaders = () => {
  const headers = { ...config.headers }
  const token = getToken()
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

// 开发环境打印配置信息
if (process.env.NODE_ENV === 'development') {
  console.log('当前环境:', process.env.NODE_ENV);
  console.log('API URL:', config.baseURL);
}

export default {
  async get(url) {
    try {
      const response = await fetch(`${config.baseURL}${url}`, {
        headers: getHeaders(),
        timeout: config.timeout
      });
      if (!response.ok) {
        if (response.status === 401) {
          // token 过期或无效，跳转到登录页
          window.location.href = '/login'
          throw new Error('登录已过期，请重新登录')
        }
        throw new Error(`请求失败: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('请求错误:', error);
      }
      throw error;
    }
  },

  async post(url, data) {
    try {
    const response = await fetch(`${config.baseURL}${url}`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
      timeout: config.timeout
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/login'
        throw new Error('登录已过期，请重新登录')
      }
      throw new Error(`请求失败: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('请求错误:', error)
    }
    throw error
  }
  },

  // 添加其他请求方法
  async put(url, data) {
    try {
    const response = await fetch(`${config.baseURL}${url}`, {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify(data),
      timeout: config.timeout
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/login'
        throw new Error('登录已过期，请重新登录')
      }
      throw new Error(`请求失败: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('请求错误:', error)
    }
    throw error
  }
  },

  async delete(url) {
    try {
    const response = await fetch(`${config.baseURL}${url}`, {
      method: 'DELETE',
      headers: config.headers,
      timeout: config.timeout
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/login'
        throw new Error('登录已过期，请重新登录')
      }
      throw new Error(`请求失败: ${response.status}`);
    }
    return response.json();
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('请求错误:', error)
    }
    throw error
  }
  },

  // // 添加获取验证码的专门方法
  // async getCaptcha() {
  //   try {
  //     const response = await fetch(`${config.baseURL}/auth/captcha`, {
  //       method: 'GET',
  //       headers: getHeaders()
  //     });
  //
  //     if (!response.ok) {
  //       throw new Error(`获取验证码失败: ${response.status}`);
  //     }
  //     return response;  // 返回原始响应，因为可能是图片
  //   } catch (error) {
  //     console.error('获取验证码失败:', error);
  //     throw error;
  //   }
  // }
};
